import { useQuery } from '@apollo/client';
import { GET_COURSE_BY_ID } from '../queries/courseById';

export const useCourseById = (contentId) => {
  const { data, loading, error } = useQuery(GET_COURSE_BY_ID, {
    variables: { id: contentId },
    skip: !contentId,
  });

  const course = data?.courses?.[0] || null;

  return { course, loading, error };
};
